export default "__VITE_ASSET__5P2uCGnqUH$YlKA7ypPFDQ__"